<div class="block-ui-template">
	<div class="m-loader m-loader--brand" style="width: 30px; display: inline-block;"></div>
	<div *ngIf="message">
		{{ message}}
	</div>
</div>